import React from 'react';
import { Popover } from '@mantine/core';
import styles from './index.module.scss';
import { translate } from '@shakkerai/util-i18n';

export const GuidePopover = (props) => {
  const {
    visible,
    position = 'top-start',
    offset = { mainAxis: 20, crossAxis: -18 },
    arrowOffset = 50,
    targetClassName,
    withinPortal = true,
    title,
    content,
    customFooter = null,
    withArrow = true,
    width = 250,
    showFooter = true,
    btnText = translate('guidance_got_button'),
    onClose = () => {},
    id,
    ...restProps
  } = props;

  return (
    <div id={id}>
      <Popover
        width={width}
        offset={offset}
        position={position}
        radius={8}
        withArrow={withArrow}
        shadow="md"
        opened={visible}
        arrowOffset={arrowOffset}
        arrowSize={15}
        arrowRadius={4}
        zIndex={888}
        withinPortal={withinPortal}
        {...restProps}
      >
        <Popover.Target>
          <div className={`${targetClassName}`}></div>
        </Popover.Target>

        <Popover.Dropdown className={styles.guidancePopover}>
          <div style={{ background: '#568FFC', padding: 20 }}>
            <div className="text-[#2D2D2D]">
              <h3 className="text-[14px] font-medium">{title}</h3>
              {!!content && <p className="mt-[12px] leading-[18px] text-[13px]">{content}</p>}
            </div>
            {!!customFooter && customFooter}
            {!customFooter && showFooter && (
              <div className="flex justify-end mt-[16px]">
                <span
                  className="h-[26px] cursor-pointer leading-[26px] text-center px-[12px] min-w-[40px] bg-[#FFF] rounded-[2px]"
                  onClick={onClose}
                >
                  {btnText}
                </span>
              </div>
            )}
          </div>
        </Popover.Dropdown>
      </Popover>
    </div>
  );
};
